import { AxiosResponse } from "axios";
import AxiosService from "./Axios";
import BaseApi from "./BaseApi";

const BASE_URL = "/big-screen";

class BigScreenApi extends BaseApi {

    constructor() {
        super(BASE_URL);
    }

    public async getAllBigScreenViews(): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/view/all');
    }
}

export default BigScreenApi;
